import { Aspect } from "@oysterhr/schema"
import { useMemo } from "react"
import { useResellerAspects } from "../queries/useResellerAspects"
import { getCurrentAspectId } from "../utils/currentAspect"
import { AccountAspectType } from "../utils/enums"

const useGetCurrentAspect = ({
  mappedAvailableAspects,
  urlAspectId,
}: {
  mappedAvailableAspects: Record<string, Aspect>
  urlAspectId: string
}): Aspect | undefined | false => {
  const currentAspectId = useMemo(
    () =>
      getCurrentAspectId({ urlAspectId, availableAspectsIds: Object.keys(mappedAvailableAspects) }),
    [mappedAvailableAspects, urlAspectId],
  )

  const { data, loading } = useResellerAspects({
    variables: { id: urlAspectId },
    skip: !urlAspectId || !!currentAspectId || urlAspectId === AccountAspectType.STAFF,
  })
  const currentResellerAspect = data?.resellerAspects?.collection[0]

  if (loading) return false

  return (
    (currentAspectId ? mappedAvailableAspects[currentAspectId] : undefined) || currentResellerAspect
  )
}

export default useGetCurrentAspect
